import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69cdaa66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewExtendedSectorForm" }
const _hoisted_2 = { class: "NewExtendedSectorForm__header" }
const _hoisted_3 = { class: "font-semibold select-none" }
const _hoisted_4 = { class: "NewExtendedSectorForm__content" }
const _hoisted_5 = {
  key: 0,
  class: "select-none text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.modalTitle), 1),
      _createElementVNode("i", {
        class: "fas fa-times cursor-pointer ml-3",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.isPaintStarted)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Обведите область на карте "))
        : (_ctx.isSectorAdded && _ctx.isCreate)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.isCreate)
                ? (_openBlock(), _createBlock(_component_new_button, {
                    key: 0,
                    loading: _ctx.loading,
                    disabled: _ctx.loading,
                    onClick: _ctx.onCreate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Добавить внешний сектор ")
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_ctx.isUpdate)
            ? (_openBlock(), _createBlock(_component_new_button, {
                key: 2,
                loading: _ctx.loading,
                disabled: _ctx.loading,
                onClick: _ctx.onUpdate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Сохранить внешний сектор ")
                ]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"]))
            : _createCommentVNode("", true),
      _createVNode(_component_new_button, {
        class: "NewButton--outline mt-3",
        disabled: _ctx.loading,
        onClick: _ctx.onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Отмена ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}